import { Link } from "react-router-dom";
import { AREA_LINKS } from "@/data/areaContent";

export const AreaLinks = ({ className = "" }) => (
  <nav aria-label="Service areas" className={`flex flex-wrap justify-center gap-x-4 gap-y-1 ${className}`} data-testid="footer-area-links">
    {AREA_LINKS.map((a) => (
      <Link key={a.slug} to={a.to} className="text-gray-400 hover:text-teal-400 text-sm font-body whitespace-nowrap" data-testid={`footer-area-${a.slug}`}>
        Valeting {a.label.split(",")[0].split(" &")[0]}
      </Link>
    ))}
  </nav>
);
